// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"MenuBar__menuBar___320Ai","collapse":"MenuBar__collapse___2KmRs"};